import Model from '~/models/Model'

export default class Application extends Model {
  static get resource () {
    return 'employer/applications'
  }
}
